import { ServiceResponse } from "@se/platform";

const ICookieServiceId = Symbol("ICookieService");

interface ICookieService {

    SaveConsentCookie(AllowMarketingCookies: boolean, AllowFunctionalCookies: boolean, AllowPerformanceCookies: boolean): Promise<ServiceResponse<string>>;
    GetConsentCookiePermissions(): Promise<ServiceResponse<string>>;
}
export { ICookieServiceId, ICookieService }